// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PbffCF08wcWqgdvy {
  width: 1200px;
  margin: 0 auto;
}
#WIKLlvcmud08bfqu {
  overflow: hidden;
}
.q4j0mVfmQprcJp9m {
  margin: 0 auto;
  width: 1136px;
  text-align: center;
  color: #999;
  font-size: 12px;
  margin-top: 12px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.q4j0mVfmQprcJp9m a {
  color: #999;
  margin-top: 3px;
}
.q4j0mVfmQprcJp9m a img {
  vertical-align: middle;
  margin-right: 5px;
}
::-webkit-scrollbar {
  margin-right: 2px;
  padding: 0 2px;
  width: 9px;
}
::-webkit-scrollbar-thumb {
  border: 2px transparent solid;
  border-radius: 20px;
  background-color: #dfdfdf;
  background-clip: padding-box;
  height: 20px;
  width: 100%;
}
`, "",{"version":3,"sources":["webpack://./app/assets/pages/home/index.modules.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,cAAA;AACF;AAEA;EACE,gBAAA;AAAF;AAGA;EACE,cAAA;EACA,aAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AADF;AATA;EAaI,WAAA;EACA,eAAA;AADJ;AAbA;EAgBM,sBAAA;EACA,iBAAA;AAAN;AAKA;EACE,iBAAA;EACA,cAAA;EACA,UAAA;AAHF;AAMA;EACE,6BAAA;EACA,mBAAA;EACA,yBAAA;EACA,4BAAA;EACA,YAAA;EACA,WAAA;AAJF","sourcesContent":[".homeWrapper {\n  width: 1200px;\n  margin: 0 auto;\n}\n\n#app {\n  overflow: hidden;\n}\n\n.footer {\n  margin: 0 auto;\n  width: 1136px;\n  text-align: center;\n  color: #999;\n  font-size: 12px;\n  margin-top: 12px;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n\n  a {\n    color: #999;\n    margin-top: 3px;\n    img {\n      vertical-align: middle;\n      margin-right: 5px;\n    }\n  }\n}\n\n::-webkit-scrollbar {\n  margin-right: 2px;\n  padding: 0 2px;\n  width: 9px;\n}\n\n::-webkit-scrollbar-thumb {\n  border: 2px transparent solid;\n  border-radius: 20px;\n  background-color: #dfdfdf;\n  background-clip: padding-box;\n  height: 20px;\n  width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"homeWrapper": `PbffCF08wcWqgdvy`,
	"app": `WIKLlvcmud08bfqu`,
	"footer": `q4j0mVfmQprcJp9m`
};
export default ___CSS_LOADER_EXPORT___;
